import React, { useEffect, useState, useContext, CSSProperties } from 'react'
import styled from 'styled-components'
import ClockLoader from "react-spinners/ClockLoader";
import UserContext from '../../business/referential/UserContext';

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const MainContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px;
`

const StepContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
  position: relative;
  :before {
    content: '';
    position: absolute;
    background: #f3e7f3;
    height: 4px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  :after {
    content: '';
    position: absolute;
    background: #3486e3;
    height: 4px;
    width: ${({ width }) => width};
    top: 50%;
    transition: 2s ease;
    transform: translateY(-50%);
    left: 0;
  }
`

const StepWrapper = styled.div`
  position: relative;
  z-index: 1;
`

const StepStyle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 3px solid ${({ step }) =>
    step === 'completed' ? '#3486e3' : '#F3E7F3'};
  transition: 2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StepCount = styled.span`
  font-size: 19px;
  color: #f3e7f3;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const StepsLabelContainer = styled.div`
  position: absolute;
  top: 75px;
  left: 50%;  
  transform: translate(-50%, -50%);
`

const StepLabel = styled.span`
  font-size: 13px;
  color: #3486e3;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 -15px;
  margin-top: 100px;
`

const ButtonStyle = styled.button`
  border-radius: 4px;
  border: 0;
  background: #3486e3;
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  width: 90px;
  :active {
    transform: scale(0.98);
  }
  :disabled {
    background: #f3e7f3;
    color: #000000;
    cursor: not-allowed;
  }
`

const CheckMark = styled.div`
  font-size: 26px;
  font-weight: 600;
  color: #3486e3;
  -ms-transform: scaleX(-1) rotate(-46deg); /* IE 9 */
  -webkit-transform: scaleX(-1) rotate(-46deg); /* Chrome, Safari, Opera */
  transform: scaleX(-1) rotate(-46deg);
`

const CheckMarkCopyright = styled.div`
  font-size: 26px;
  font-weight: 600;
  color: #3486e3;
  -ms-transform: scaleX(-1) rotate(-180deg); /* IE 9 */
  -webkit-transform: scaleX(-1) rotate(-180deg); /* Chrome, Safari, Opera */
  transform: scaleX(-1) rotate(-180deg);
`

const ProgressStepsEmail = ({ show, done, setComplete }) => {
  const [activeStep, setActiveStep] = useState(1)
  const [finish, setFinish] = useState(false)
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#3486e3;");
  const [userData, setUserData] = useState(null);
  const ctx = useContext(UserContext);
  const [pageId, setPageId] = useState(16);
  const [steps, setSteps] = useState([]);

  useEffect(() => {

    if (userData) {
      setSteps([
        {
          label: getContent("CR_EMAIL_1"),
          step: 1,
        },
        {
          label: getContent("CR_EMAIL_2"),
          step: 2,
        },
        {
          label: getContent("CR_EMAIL_3"),
          step: 3,
        },
        {
          label: getContent("CR_EMAIL_4"),
          step: 4,
        },
      ]);
    }

  }, [userData]);

  const getContent = (key) => {
    if (userData) {
      if (userData.dataContent[pageId][key]) {
        var str = userData.dataContent[pageId][key].contentTxt;
        const regex = /(<([^>]+)>)/ig;
        const newString = str.replace(regex, '');
        return newString;
      }
    }
    return '';
  }

  useEffect(() => {

    const process = async () => {

      Promise.resolve(ctx).then(value => {
        setUserData(value);
      });

    }
    process();

  }, []);

  useEffect(() => {

    if (activeStep < 4)
      nextStep();
    else {
      setLoading(true);
      setTimeout(() => setFinish(true), 2000);
    }

  }, [show, activeStep]);


  useEffect(() => {

    if (finish && done) {
      setComplete(true);
    }

  }, [finish, done]);

  const nextStep = () => {
    setTimeout(() => setActiveStep(activeStep + 1), 1000);
  }

  const totalSteps = steps.length

  const width = `${(100 / (totalSteps - 1)) * (activeStep - 1)}%`

  return (
    <MainContainer>
      <StepContainer width={width}>
        {steps.map(({ step, label }) => (
          <StepWrapper key={step}>
            <StepStyle step={activeStep >= step ? 'completed' : 'incomplete'}>
              {activeStep > step ? (
                <CheckMark>L</CheckMark>
              ) : (
                (activeStep === step && done) ? <CheckMarkCopyright>©</CheckMarkCopyright> : (activeStep === 4) ? <StepCount>
                  <ClockLoader
                    color={"#0d6efd"}
                    loading={loading}
                    cssOverride={override}
                    size={30}
                    aria-label="Loading"
                    data-testid="loader"
                  />
                </StepCount> : <StepCount>{step}</StepCount>
              )}
            </StepStyle>
            <StepsLabelContainer>
              <StepLabel key={step}>{label}</StepLabel>
            </StepsLabelContainer>
          </StepWrapper>
        ))}
      </StepContainer>
    </MainContainer>
  )
}

export default ProgressStepsEmail